import React from "react";
// import MaskedInput from "react-maskedinput";
import MaskedInput from "react-text-mask";

export default function UniqueRegisterCenterInput(props) {
  return <MaskedInput 
  mask={[ /\d/, /\d/, /\d/, /\d/ ]}
  guide={false}
  placeholder="" {...props} />;
  
}
